export const QUERY_KEYS = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  VERIFY_EMAIL_OTP: 'VERIFY_EMAIL_OTP',
  VERIFY_EMAIL_TOKEN: 'VERIFY_EMAIL_TOKEN',
  RESEND_EMAIL_OTP: 'RESEND_EMAIL_OTP',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  SAVE_AGENCY_DETAILS: 'SAVE_AGENCY_DETAILS',
  GET_AGENCY_PROFILE: 'GET_AGENCY_PROFILE',
  SAVE_TALENT_DETAILS: 'SAVE_AGENCY_DETAILS',
  GET_LANGUAGES: 'GET_LANGUAGES',
  GET_INDUSTRIES: 'GET_INDUSTRIES',
  GET_CERTIFICATES: 'GET_CERTIFICATES',
  GET_TECH_SPHERES: 'GET_TECH_SPHERES',
  GET_LANG_FROM_SPHERES: 'GET_LANG_FROM_SPHERES',
  GET_FRAMEWORKS_FROM_SPHERES: 'GET_FRAMEWORKS_FROM_SPHERES',
  GET_FRAMEWORKS: 'GET_FRAMEWORKS',
  UPLOAD_TALENT_VIDEO: 'UPLOAD_TALENT_VIDEO',
  GET_TALENTS: 'GET_TALENTS',
  GET_TALENT_UPLOADED_VIDEO: 'GET_TALENT_UPLOADED_VIDEO',
  AGENCY_RATE_SETUP: 'AGENCY_RATE_SETUP',
  PUBLISH_OR_UNPUBLISH_TALENT: 'PUBLISH_OR_UNPUBLISH_TALENT',
  UPDATE_PINNED_OR_UNPINNED_TALENT: 'UPDATE_PINNED_OR_UNPINNED_TALENT',
  VALIDATE_VIMEO_VIDEO: 'validate-vimeo-video',
  GET_RATE_SETUP: 'GET_RATE_SETUP',
  GET_TALENT_DETAILS: 'GET_TALENT_DETAILS',
  DELETE_TALENT_DETAILS: 'DELETE_TALENT_DETAILS',
  RESUME_UPLOAD_FLOW: 'RESUME_UPLOAD_FLOW',
  DELETE_TALENT_RESUME: 'DELETE_TALENT_RESUME',
  GET_TALENT_RESUME: 'GET_TALENT_RESUME',
  DELETE_TALENT_UPLOADED_VIDEO: 'DELETE_TALENT_UPLOADED_VIDEO',
  VALIDATE_EXISTING_EMAIL: 'VALIDATE_EXISTING_EMAIL',
  UPLOAD_AGENCY_VIDEO: 'UPLOAD_AGENCY_VIDEO',
} as const;
